<template>
  <div>
    <modal :size="'modal-small'"
           :close-strict="true"
           @close="$emit('close')"
    >
      <div slot="header" />
      <div class="modal-body-scroll" slot="body">
        <div class="loader-circle" v-show="loading" />
        <div class="row are-you-sure-wrapper" :class="[loading ? 'opacity-2' : '']">
          <div class="col-md-12 text-center mb-3">
            <img src="../../../assets/img/monster.svg" />
          </div>
          <div class="col-md-12 text-center mb-2">
            <p>
              This will return the job to status "Total time", it will not affect total hours, price nor tracking. A new completion email will be sent to the customer after you complete the job again.
            </p>
            <p>
              Do you confirm?
            </p>
          </div>
          <div class="col-md-12 text-center are-you-sure-actions mt-4">
            <div class="d-flex align-items-center mt-3">
              <button class="btn btn-secondary" @click="$emit('close')">
                No
              </button>
            </div>
            <div class="d-flex align-items-center mt-3">
              <button class="btn btn-primary" @click="revertToTotalTime">
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" />
    </modal>
  </div>
</template>

<script>
import Modal from '../../Modal';

export default {
  name: 'AreYouSureRevertToTotalTime',
  components: {
    Modal,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    loading(newVal) {
      if (newVal === false) {
        this.$emit('close');
      }
    },
  },
  methods: {
    revertToTotalTime() {
      this.$emit('revertToTotalTime');
    },
  },
};
</script>

<style lang="scss" scoped>
.are-you-sure-wrapper {
  padding: 15px 15px 0 15px;
}
.are-you-sure-actions {
  display: flex;
  justify-content: space-around;
}
.opacity-2 {
  opacity: 0.2;
}
.loader-circle {
  margin-bottom: 30px;
  border: 3px solid rgba(0, 0, 0, 0);
  border-left-color: #2962ff;
  -webkit-animation: loader-spin 1.2s infinite linear;
  animation: loader-spin 0.7s infinite linear;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  z-index: 10000;
  position: absolute;
  top: 43%;
  right: 40%;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/modals/AreYouSureRevertToTotalTime.vue